import { useQuery, QueryOptions } from 'react-query';

import PicTransactionsService from '../../services/picTransactionsService';

const useManagePicTransactionsQuery = ({
  organizationId,
  propertyId,
  startDate,
  endDate,
  options = {},
}: {
  organizationId: string,
  propertyId: string,
  startDate?: string,
  endDate?: string,
  options?: QueryOptions,
}) => {
  const picTransactionsService = new PicTransactionsService();
  const queryKey = ['getAllPicTransactions', organizationId, propertyId];

  const { data, isLoading, refetch } = useQuery(
    queryKey,
    async () => {
      const response = await picTransactionsService.getAllPicTransactions(
        organizationId,
        propertyId,
        startDate,
        endDate,
      );
      return response;
    },
    { refetchOnWindowFocus: false, ...options },
  );

  return {
    data,
    isLoading,
    refetch,
  };
};

export default useManagePicTransactionsQuery;
